// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__23Dsb","brand":"Footer_brand__bP0Lb"};